import { useAuthStore as s } from "../store.es.js";
const u = () => {
  const t = s();
  return {
    state: t,
    isLoading: !t.status || t.status === "loading"
  };
};
export {
  u as useAuth
};
